export const INPUT_MAX_LENGTH = 200;

export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

// Usernames are validated far more strictly on the server than e-mail addresses are, so
// the logged-out funnel asks for the two separately instead of treating them as one value.
// Anything outside this character set — notably "+", which is perfectly legal in an
// address and is what the "user+tag@gmail.com" trick for test accounts relies on — comes
// back from the backend as "System.Exception: Illegal characters detected in input or
// input too long." and the whole request fails.
//
// If the backend ever states its exact rule, this is the single place to change it.
export const USERNAME_MIN_LENGTH = 3;
export const USERNAME_MAX_LENGTH = 64;
export const USERNAME_PATTERN = /^[A-Za-z0-9._@-]+$/;

// Both validators are shared by every logged-out form that takes these values (sign-up and
// reset password) so the two screens can't drift apart: they return a translated error
// message, or true when the value is acceptable — the shape react-hook-form's `validate`
// option expects. `t` is passed in rather than imported so the message follows a language
// switch like every other string in these forms.
export const validateEmailFormat = (value, t) =>
    EMAIL_PATTERN.test((value || "").trim()) || t("Invalid email address");

export const validateUsernameFormat = (value, t) => {
    const username = (value || "").trim();
    if (username.length < USERNAME_MIN_LENGTH)
        return t("Username is too short");
    if (username.length > USERNAME_MAX_LENGTH)
        return t("Username is too long");
    return USERNAME_PATTERN.test(username) || t("Username can only contain letters, numbers and the characters . _ - @");
};

// For the paths where no username can be asked for (Google sign-up hands us an e-mail and
// nothing else): drop every character the server would reject. Returns null when what's
// left is unusable, in which case the caller should send no username at all and let the
// backend derive one from the name/e-mail per its own rules.
export const sanitizeUsername = (value) => {
    const cleaned = (value || "")
        .toLowerCase()
        .replace(/[^a-z0-9._@-]/g, "")
        .slice(0, USERNAME_MAX_LENGTH);
    return cleaned.length >= USERNAME_MIN_LENGTH ? cleaned : null;
};
